// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from '../core/scenes/BaseScene';
import UIPositionContainer from '../core/components/UIPositionContainer';
/* START-USER-IMPORTS */
import { DebugInput } from '../core/modules/DebugInput';
/* END-USER-IMPORTS */

export default class DebugUI extends BaseScene {
  constructor() {
    super('DebugUI');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // Overlay
    const overlay = this.add.container(63, 184);

    // textFPS
    const textFPS = this.add.text(-61, -25, '', {});
    textFPS.setOrigin(0, 0.5);
    textFPS.text = 'fps: 00';
    textFPS.setStyle({ fontFamily: 'Arial', fontSize: '24px' });
    overlay.add(textFPS);

    // textDelta
    const textDelta = this.add.text(-61, 0, '', {});
    textDelta.setOrigin(0, 0.5);
    textDelta.text = 'delta: 00';
    textDelta.setStyle({ fontFamily: 'Arial', fontSize: '24px' });
    overlay.add(textDelta);

    // textRawDelta
    const textRawDelta = this.add.text(-61, 25, '', {});
    textRawDelta.setOrigin(0, 0.5);
    textRawDelta.text = 'rawDelta: 00';
    textRawDelta.setStyle({ fontFamily: 'Arial', fontSize: '24px' });
    overlay.add(textRawDelta);

    // textTargetFPS
    const textTargetFPS = this.add.text(-61, -51, '', {});
    textTargetFPS.setOrigin(0, 0.5);
    textTargetFPS.text = 'targetFPS: 00';
    textTargetFPS.setStyle({ fontFamily: 'Arial', fontSize: '24px' });
    overlay.add(textTargetFPS);

    // overlay (components)
    const overlayUIPositionContainer = new UIPositionContainer(overlay);
    overlayUIPositionContainer.offsetX = 12;
    overlayUIPositionContainer.PinLeft = true;

    this.overlay = overlay;
    this.textFPS = textFPS;
    this.textDelta = textDelta;
    this.textRawDelta = textRawDelta;
    this.textTargetFPS = textTargetFPS;

    this.events.emit('scene-awake');
  }

  private overlay!: Phaser.GameObjects.Container;
  private textFPS!: Phaser.GameObjects.Text;
  private textDelta!: Phaser.GameObjects.Text;
  private textRawDelta!: Phaser.GameObjects.Text;
  private textTargetFPS!: Phaser.GameObjects.Text;

  /* START-USER-CODE */
  public static registryKeys = {} as const;
  public static events = {
    ToggleDebugOverlay: 'toggleDebugOverlay'
  } as const;

  protected debugInput!: DebugInput;

  public create() {
    this.editorCreate();
    this.hideDebugOverlay();

    this.debugInput = new DebugInput(this);

    this.textTargetFPS.text = `targetFPS: ${this.sys.game.loop.targetFps}`;

    this.events.on(DebugUI.events.ToggleDebugOverlay, this.toggleDebugOverlay, this);

    console.log('Debug created');
  }

  public update() {
    if (this.overlay.visible) {
      let loop = this.sys.game.loop;
      let targetFPSPercent = loop.actualFps / loop.targetFps;
      let deltaPercent = 0.001 * loop.delta * loop.targetFps;

      this.textFPS.text = `fps: ${loop.actualFps.toFixed(2)} (${(100 * targetFPSPercent).toFixed(0).padStart(3, ' ')}%)`;
      this.textDelta.text = `delta: ${loop.delta.toFixed(2)} (${(100 * deltaPercent).toFixed(0).padStart(3, ' ')}%)`;
      this.textRawDelta.text = `rawDelta: ${loop.rawDelta.toFixed(2)}`;
    }
  }

  public shutdown() {
    this.events.off(DebugUI.events.ToggleDebugOverlay, this.toggleDebugOverlay, this);

    super.shutdown();
  }

  public destroy() {
    super.destroy();
  }

  protected toggleDebugOverlay() {
    this.overlay.setVisible(!this.overlay.visible);
  }

  protected showDebugOverlay() {
    this.overlay.setVisible(true);
  }

  protected hideDebugOverlay() {
    this.overlay.setVisible(false);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
